import ImageCombinedView from './ImageCombinedView'

export default ImageCombinedView
